export type Project = {
    id: string;
    projectNumber: string | null;
    organizationName: string;
    organizationId: string;
    clientProjectNumber: string;
    projectManagerName: string | null;
    projectManagerId: string | null;
    pipeline: string;
    subPipeline: string;
    stage: string;
    reportNeeded: "no" |"yes";
    prevailing: "no" |"yes";
    cpr: "no" |"yes";
    dirNumber: string;
    location: string;
    coords: string;
    nearestMedicalFacility: string;
    opportunityId: string | null;
    opportunityName: string | null;
    proposalId: string | null;
    proposalNumber: string | null;
    requestorId: string | null;
    requestor: string;
    clientPONumber: string;
    region: string;
    billingType: string;
    days: string;
    laborHours: string;
    materialCost: string;
    budgets: { amount: string, start: string, end: string, endUnknown: boolean }[];
    description: string;
    notes: string;
    accurateTime: "no" |"yes";
    clientSignatureRequired: "no" |"yes";
    sendToClient: "no" |"yes";
    usaTicketNumber: string;
    usaTicketDate: string;
    usaTicketExpirationDate?: string;
    projectCreationDate: string;
    projectDateUpdated: string;
    projectCreatorName: string;
    projectUpdaterName: string;
    projectCreatorId: string;
    projectUpdaterId: string;
    statusChanger: string;
    statusChangerId: string;
    statusChangeDateTime: string;
    folderId: string;
    projectFiles: any[];
    budget: string;
    reportLink: string;
    reportCreationDate: string;
    cctv: string;
    KML: string;
    rate: string;
    profit: string;
    reportTechId: string;
    reportTechName: string;
    contacts: {label: string, value: string}[];
    [key: string]: any;
};

export type ProjectOpportunity = {
    opportunityId: string;
    opportunityName: string;
    [key: string]: any;
};

export type ProjectContact = {
    contactid: string;
    firstName: string;
    lastName: string;
    organizationId: string;
    organizationName: string;
    [key: string]: any;
};

export type ProjectOrganization = {
    id: string;
    name: string;
};

export const defaultProject: Project = {
    id: "",
    projectNumber: null,
    organizationName: "",
    organizationId: "",
    clientProjectNumber: "",
    projectManagerName: "",
    projectManagerId: "",
    pipeline: "",
    subPipeline: "",
    stage: "",
    reportNeeded: "no",
    prevailing: "no",
    cpr: "no",
    dirNumber: "",
    location: "",
    coords: "",
    nearestMedicalFacility: "",
    opportunityId: null,
    opportunityName: "",
    proposalId: null,
    proposalNumber: "",
    requestorId: null,
    requestor: "",
    clientPONumber: "",
    region: "",
    billingType: "",
    days: "",
    laborHours: "",
    materialCost: "",
    budgets: [],
    description: "",
    notes: "",
    accurateTime: "no",
    clientSignatureRequired: "no",
    sendToClient: "no",
    usaTicketNumber: "",
    usaTicketDate: "",
    projectCreationDate: "",
    projectDateUpdated: "",
    projectCreatorName: "",
    projectUpdaterName: "",
    projectCreatorId: "",
    projectUpdaterId: "",
    statusChanger: "",
    statusChangerId: "",
    statusChangeDateTime: "",
    folderId: "",
    projectFiles: [],
    budget: "",
    reportLink: "",
    reportCreationDate: "",
    cctv: "",
    KML: "",
    rate: "",
    profit: "",
    reportTechId: "",
    reportTechName: "",
    contacts: [],
};
